import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import { Link } from 'react-router-dom';

function ChickenRoadPromo(props) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const isFomo = (brandId == 39 || brandId == 40)
    const is_crypto = (brandId == 61)
    
    const domain = (brandId == 31 || brandId == 32 || brandId == 61) ? "Yolo247" : (brandId == 39 || brandId == 40) ? "Fomo7": 'Iw247';

    return (
        <>
            <InformationWrapper>
                <ImageWrapper>
                    <Container $isFomo={isFomo}>
                          <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.chickenRoadFirstSec}`}
                                alt="How to participate"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                           />
                           <Link to='/instant-games/inout/chicken-road-2' className='playNowBtn'><span>Play Now</span></Link>
                    </Container>
                </ImageWrapper> 

                <KeyDetailsSec>
                    <MainTitle>How to participate</MainTitle>
                    <KeyDetailsSecWrap>
                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.chickenRoadParticipateIcon1}`}/>
                            <p>Place 26 cash bet on chicken road 2 & get 26 free spins</p>
                        </KeyDetailsSecBox>
                             
                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.suprChknRushParticipateIcon2}`}/>
                            <p className='brandColor'>Qualify automatically</p>
                        </KeyDetailsSecBox>

                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.chickenRoadParticipateIcon1}`}/>
                            <p>Receive 26 free spins on <br /> Chicken Road 2</p>
                        </KeyDetailsSecBox>
                    </KeyDetailsSecWrap>
                </KeyDetailsSec>

                <TermsAndCondition>
                    <MainTitle>Terms & Conditions</MainTitle>
                    <ul>
                        <li>✪ Valid from <strong>01 Jan 2026 to 28 February 2026</strong></li>
                        <li>✪ Free spin value: <strong>{is_crypto ? "$0.01" : "₹1"}</strong></li>
                        <li>✪ Valid for the first <strong>1,000 eligible players</strong></li>
                        <li>✪ Estimated total prize pool: <strong>{is_crypto ? "$130,000" : "₹13,00,000"}</strong></li>
                        <li>✪ Slot bonus rules apply</li>
                        <li>✪ Bonus winnings subject to wagering</li>
                        <li>✪ General <strong>{domain}</strong> terms & conditions apply</li>
                    </ul>
                </TermsAndCondition>
            </InformationWrapper>
        </>
    )
}



export default withTheme(withAppContext(ChickenRoadPromo));

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 2rem 0 5rem 0;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.chickenRoadMainInnerBg")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;

    h2 {
        color: #FAFF00;
        text-align: center;
        font-size: 23px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
    }
`;

const ImageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 2rem;
    position: relative;
    padding-top: ${theme('palette.suprChknRushImageWraprPaddngTop')};

    img {
        width: 93px;
    }

    .customMargin {
        margin: -7px 0px -20px 0px;
    }
`;

const Container = styled.div<{ $isFomo?: boolean }>`
    width: 275px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    & img {
      width: 100%;
      height: auto;
    }

    .playNowBtn {
        width: 220px;
        height: 65px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${theme('palette.freeSpinChickenRoadPromoBtnColr')};
        font-size: ${({ $isFomo }) => ($isFomo ? "35px" : "20px")};
        font-style: ${({ $isFomo }) => ($isFomo ? "italic" : "normal")};
        font-family: ${({ $isFomo }) => $isFomo ? "parimatchregularregular" : "Inter"};
        font-weight: 700;
        text-transform: uppercase;
        margin-top: 1.5rem;
        border-radius: 59px;
        border: ${theme('palette.freeSpinChickenRoadPromoBtnBorder')};
        background: ${theme('palette.freeSpinChickenRoadPromoBtnBgColor')};

        &:hover {
            ${({ $isFomo }) =>
                $isFomo
                    ? `
                    background: linear-gradient(180deg, #1C91FF 0%, #0046FF 100%);
                    color: #0f3faf;
                    border: none;
                `
                : `
                    background: #fff;
                    border: 3px solid #bebebe;
                `}
        }
    }
`;

const MainTitle = styled.h4`
    color: ${theme('palette.freeSpinChickenRoadMainTitleColr')};
    /* color: #FAFF00; */
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 35px; /* 175% */
    text-transform: capitalize;
    margin: 3px 0px 15px 0px;
`;

const KeyDetailsSec = styled.div`
    display: flex;
    flex-direction: column;
    margin: 2rem auto;
    width: 70%;
    height: auto;
`;

const KeyDetailsSecWrap = styled.div`
    display: flex;
    justify-content: center;
    gap: 20px;
`;

const KeyDetailsSecBox = styled.div`
    width: 313px;
    height: 190px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
    border-radius: 14px;
    border: ${theme('palette.freeSpinChiknRodPrmoKeyDetailsSecBxBrdr')};
    background: ${theme('palette.freeSpinChiknRodPrmoKeyDetailsSecBxBgClr')};

    img {
        width: 61px;
    }

    & p {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px; /* 133.333% */
        text-transform: capitalize;
        margin: 3px 0px;
        width: 80%;
    }
`;

const TermsAndCondition = styled.div`
    width: 35%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 2rem auto;
    border-radius: 14px;
    padding: 1rem;    
    border: ${theme('palette.freeSpinChiknRodPrmoT&CBrdr')};
    background: ${theme('palette.freeSpinChiknRodPrmoT&CBgClr')};
    backdrop-filter: blur(12px);
    
    ul {
        list-style: none;
        padding: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;

        li {
            color: #fff;
            font-size: 16px;
            text-transform: capitalize;
        }
    }
`;